import * as React from "react";
import PlaceholderInfo from "./PlaceholderInfo";
import PlaceholderBtn from "./PlaceholderBtn";
export class EventCardPlaceholder extends React.PureComponent {
    renderItems(eventsCount) {
        const elements = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: `ev-card-placeholder__item__${i}`, className: `rj-ev-list__ev-card-placeholder__items-wrap` },
                React.createElement(PlaceholderInfo, null),
                React.createElement(PlaceholderBtn, null)));
        }
        return elements;
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__ev-card-placeholder` },
            React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__header` },
                React.createElement("div", { className: `rj-ev-list__ev-card-placeholder__header-text` })),
            this.renderItems(this.props.eventsCount)));
    }
}
//# sourceMappingURL=EventCardPlaceholder.js.map